import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    clearBetSlip,
    fetchBetSlipEvents,
    getBetDetails,
    startPlaceBetRequest,
} from '../../store/actions/betSlip';
import Tabs from './Tabs/Tabs';
import Loading from './Loading/Loading';
import PlacedCoupon from './PlacedCoupon/PlacedCoupon';
import TicketDetails from './TicketDetails/TicketDetails';
import { getTranslation } from '../../utils/translation';
import styles from './BetSlip.module.scss';
import { fetchProducerStatuses } from '../../store/actions/feed';
import PlacedTicket from './PlacedTicket/PlacedTicket';
import { useProducerStatusToast } from '../../hooks/useProducerStatusToast';

const BetSlip = ({ isLive }) => {
    const dispatch = useDispatch();

    const placedTicketDetails = useSelector(state => state.betSlip.placedTicketDetails);
    const isFetchingEvents = useSelector(state => state.betSlip.isFetchingEvents);
    const isTicketSubmitting = useSelector(state => state.betSlip.isTicketSubmitting);
    const betLines = useSelector(state => state.betSlip.betLines);
    const requestId = useSelector(state => state.betSlip.requestId);

    useProducerStatusToast({ className: styles.producerToast, isLive });

    const verifyTicketTimeout = useRef(null);

    useEffect(() => {
        dispatch(fetchBetSlipEvents());
        dispatch(fetchProducerStatuses());
    }, []);

    useEffect(() => {
        if (requestId !== null) {
            const maxTimeout = betLines.some(betLine => betLine.isLive) ? 35 * 1000 : 10 * 1000;
            const elapsedTime = Date.now() - requestId.createDate;
            const remainingTimeout = maxTimeout - elapsedTime;

            dispatch(startPlaceBetRequest());

            verifyTicketTimeout.current = setTimeout(() => {
                dispatch(getBetDetails(requestId.requestId));
            }, remainingTimeout);
        } else {
            clearTimeout(verifyTicketTimeout.current);
        }
    }, [requestId]);

    const resetBetSlip = () => {
        dispatch(clearBetSlip());
    };

    return (
        <div className={styles.betSlip}>
            <Tabs />

            <Loading
                loading={isTicketSubmitting}
                title={getTranslation('betSlip.placeBets.betsInProcess')}
                description={getTranslation('betSlip.placeBets.loadingInfoMessage')}
            />

            <Loading
                loading={isFetchingEvents}
                title={getTranslation('betSlip.refresh.loadingTitle')}
                description={getTranslation('betSlip.refresh.loadingInfoMessage')}
            />

            {placedTicketDetails && placedTicketDetails.couponNumber && (
                <PlacedCoupon resetBetSlip={resetBetSlip} />
            )}
            {placedTicketDetails && placedTicketDetails.ticketNumber ? (
                <PlacedTicket resetBetSlip={resetBetSlip} />
            ) : (
                <TicketDetails resetBetSlip={resetBetSlip} />
            )}
        </div>
    );
};

export default BetSlip;
